import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import ButtonTable from '../common/table/buttonTable';
import Button from '../common/button/button';
import { setError } from '../common/toast/toast';
import readXlsxFile from 'read-excel-file/web-worker'
import ReactExport from 'react-export-excel-fixed-xlsx';

import {
	setModoTela, initForm, salvar, excluir, processarApuracao, getListaMetaApuracao, importarCustos, imprimir
} from './metaBaseSupervisorTrimestreActions';
import LabelAndInputMask from '../common/form/labelAndInputMask';
import Select from '../common/form/select';
import FormatUtils from '../common/formatUtils/FormatUtils';
import DateFormat from '../common/dateFormat/DateFormat';
import LabelAndCheckbox from '../common/form/labelAndCheckbox';

class MetaBaseSupervisorTrimestreApuracao extends Component {

	state = {
		linhaSelecionada: null,
		pesquisar: '',
		ano: new Date().getFullYear(),
		trimestre: new Date().getMonth() <= 2 ? 1 : (new Date().getMonth() <= 5 ? 2 : (new Date().getMonth() <= 8 ? 3 : 4))
	}

	componentDidMount() {

		const fileSelector = document.createElement('input');
		fileSelector.setAttribute('type', 'file');
		fileSelector.addEventListener("change", async (data) => {

			let reader = new FileReader();
			let file = data && data.path && data.path[0] && data.path[0].files && data.path[0].files[0] ? data.path[0].files[0] : null;
			if (!file) {
				file = data && data.target && data.target.files && data.target.files[0] ? data.target.files[0] : null;
			}

			if (file) {

				if (!file.type.includes('application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')
					|| (file.type.includes('application/excel') || file.type.includes('application/vnd.ms-excel'))) {
					setError('Selecione apenas (.XLSX)');
					return;
				}

				let tabela = [];
				await readXlsxFile(file, { sheet: 1 }).then((rows) => {
					tabela = rows;
				});

				this.props.importarCustos(tabela);

				reader.readAsDataURL(file);

			}
		});

		this.fileSelector = fileSelector;

	}

    componentWillMount() {
        this.props.getListaMetaApuracao();
    }


    render() {
        return (
            <div>
                <Content>
					{this.lista()}
                </Content>
            </div>
        )
    }

	lista() {

		const ExcelFile = ReactExport.ExcelFile;
		const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
		const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

		const perfilAdministrador = this.props.usuarioCarregado && this.props.usuarioCarregado.id_perfil == 2;
		
		return (
			<ContentCard>

				{this.modalReprocessar()}

				<ContentCardBody>
					<Row>

						<Select
							options={[{ id: 2025, valor: 2025 }, { id: 2026, valor: 2026 }]}
							label='Ano'
							cols='12 4 3 2'
							placeholder='Selecione o ano'
							value={this.state.ano}
							onChange={value => {
								this.setState({
									...this.state,
									ano: value
								});
							}} />
								
						<Select
							options={[{ id: 1, valor: '1º trimestre' }, { id: 2, valor: '2º trimestre' }, { id: 3, valor: '3º trimestre' }, { id: 4, valor: '4º trimestre' } ]}
							label='Trimestre'
							cols='12 4 3 2'
							placeholder='Selecione o trimestre'
							value={this.state.trimestre}
							onChange={value => {
								this.setState({
									...this.state,
									trimestre: value
								});
							}} />
					</Row>
					 {console.log(this.props.lista)}
					 
					{this.props.lista.filter(item => {
						if (this.state.ano && this.state.trimestre) {
							return item.ano == this.state.ano && item.trimestre == this.state.trimestre;
						}
						return false;
					}).filter(item => {
						if (!this.props.usuarioCarregado) {
							return false;
						} else if (!perfilAdministrador && item.id_usuario != this.props.usuarioCarregado.id) {
							return false;
						} else {
							return true;
						}
					}).map(item => {
						
						return (
							<Table responsive key={item.id} border>
								<THead>
									<Tr backgroundColor={'#dfe2f5'}>
										<Th fontSize={18}>
											{item.nome_usuario} ({item.id_usuario})
											{/*perfilAdministrador &&
											<button 
												type='button'
												class='btn btn-success btn-flat'
												style={{ marginLeft: 16 }}
												onClick={() => {
													this.setModalReprocessar({ ...item });
												}}>
												<i class='fas fa-sync' style={{ fontSize: 18 }}></i>
											</button>*/}
											{perfilAdministrador &&
											<button 
												type='button'
												class='btn btn-primary btn-flat'
												style={{ marginLeft: 16 }}
												onClick={() => {
													this.props.imprimir({ 
														...item,
														ano_trimestre: `${item.trimestre}° trimestre de ${item.ano}`,

														visita_qualidade_nome: 'Indicador I — Visita de Qualidade',
														visita_qualidade_peso: `${FormatUtils.formatarValorTelaDecimal(item.visita_qualidade_peso, 2)}%`,
														visita_qualidade_meta: `${FormatUtils.formatarValorTelaDecimal(item.visita_qualidade_meta, 0)}`,
														visita_qualidade_estoque_realizado: `${FormatUtils.formatarValorTelaDecimal(item.visita_qualidade_realizado, 0)}`,
														visita_qualidade_percentual: `${FormatUtils.formatarValorTelaDecimal(item.visita_qualidade_percentual_realizado, 2)}%`,
																																									
														estoque_nome: 'II — Ajuste de Estoque (Perda)',
														estoque_peso: `${FormatUtils.formatarValorTelaDecimal(item.estoque_peso, 2)}%`,
														estoque_meta: `${FormatUtils.formatarValorTelaDecimal(item.estoque_meta_faixa4, 2)}%`,
														estoque_estoque_realizado: `${FormatUtils.formatarValorTelaDecimal(item.estoque_realizado, 2)}% - ${item.estoque_percentual_realizado_faixa_realizado}`,
														estoque_percentual: `${FormatUtils.formatarValorTelaDecimal(item.estoque_percentual_realizado, 2)}%`,

														performance_operador_nome: 'Indicador III — Performance Operadores de Base',
														performance_operador_peso: `${FormatUtils.formatarValorTelaDecimal(item.performance_operador_peso, 2)}%`,
														performance_operador_meta: `${FormatUtils.formatarValorTelaDecimal(100, 2)}%`,
														performance_operador_estoque_realizado: `${FormatUtils.formatarValorTelaDecimal(item.performance_operador_realizado, 2)}%`,
														performance_operador_percentual: `${FormatUtils.formatarValorTelaDecimal(item.performance_operador_percentual_realizado, 2)}%`,

														//Total
														total_meta: `${FormatUtils.formatarValorTelaDecimal(
															parseFloat(item.visita_qualidade_peso || 0) 
															+ parseFloat(item.estoque_peso || 0) 
															+ parseFloat(item.performance_operador_peso || 0), 2)
														}%`,
														total_realizado: `${FormatUtils.formatarValorTelaDecimal(
															parseFloat(item.visita_qualidade_percentual_realizado || 0) 
															+ parseFloat(item.estoque_percentual_realizado || 0) 
															+ parseFloat(item.performance_operador_percentual_realizado || 0), 2)
														}%`
													});
												}}>
												<i class='fas fa-file-pdf' style={{ fontSize: 18 }}></i>
											</button>}
											{/*
											<button 
												type='button'
												class='btn btn-default btn-flat'
												style={{ marginLeft: 16 }}
												onClick={() => {
													this.props.imprimir({
														...item,
														nome: item.nome_usuario,
														ano_trimestre: `${item.trimestre}° trimestre de ${item.ano}`
													});															
												}}>
												<i class='fas fa-file-pdf' style={{ fontSize: 18 }}></i>
											</button>*/}
										</Th>
										<Th alignCenter fontSize={18}>Peso</Th>
										<Th alignCenter fontSize={18}>Meta</Th>
										<Th alignCenter fontSize={18}>Realizado</Th>
										<Th alignCenter fontSize={18}>Percentual</Th>
									</Tr>
								</THead>
								<TBody>
									<Tr>
										<Td width={500}>Indicador I — Visita de Qualidade</Td>
										<Td width={100} alignCenter fontSize={18}>{FormatUtils.formatarValorTelaDecimal(item.visita_qualidade_peso, 2)}%</Td>
										<Td width={100} alignCenter fontSize={18}>{FormatUtils.formatarValorTelaDecimal(item.visita_qualidade_meta, 0)}</Td>
										<Td width={100} alignCenter fontSize={18}>{FormatUtils.formatarValorTelaDecimal(item.visita_qualidade_realizado, 0)}</Td>
										<Td width={100} alignCenter fontSize={18}>{FormatUtils.formatarValorTelaDecimal(item.visita_qualidade_percentual_realizado, 2)}%</Td>
									</Tr>

									<Tr>
										<Td width={500}>Indicador II — Ajuste de Estoque (Perda)</Td>
										<Td width={100} alignCenter fontSize={18}>{FormatUtils.formatarValorTelaDecimal(item.estoque_peso, 2)}%</Td>
										<Td width={100} alignCenter fontSize={18}
											title={
												`Faixa 1: ${FormatUtils.formatarValorTelaDecimal(item.estoque_meta_faixa1, 2)}% = ${FormatUtils.formatarValorTelaDecimal(item.estoque_percentual_faixa1, 2)}%`
												+ `\nFaixa 2: ${FormatUtils.formatarValorTelaDecimal(item.estoque_meta_faixa2, 2)}% = ${FormatUtils.formatarValorTelaDecimal(item.estoque_percentual_faixa2, 2)}%`
												+ `\nFaixa 3: ${FormatUtils.formatarValorTelaDecimal(item.estoque_meta_faixa3, 2)}% = ${FormatUtils.formatarValorTelaDecimal(item.estoque_percentual_faixa3, 2)}%`
												+ `\nFaixa 4: ${FormatUtils.formatarValorTelaDecimal(item.estoque_meta_faixa4, 2)}% = ${FormatUtils.formatarValorTelaDecimal(item.estoque_percentual_faixa4, 2)}%`
											}
											>{FormatUtils.formatarValorTelaDecimal(item.estoque_meta_faixa4, 2)}%</Td>
										<Td width={100} alignCenter fontSize={18}>{FormatUtils.formatarValorTelaDecimal(item.estoque_realizado, 2)}% - {item.estoque_percentual_realizado_faixa_realizado}</Td>
										<Td width={100} alignCenter fontSize={18}>{FormatUtils.formatarValorTelaDecimal(item.estoque_percentual_realizado, 2)}%</Td>
									</Tr>
									
									<Tr>
										<Td width={500}>Indicador III — Performance Operadores de Base</Td>
										<Td width={100} alignCenter fontSize={18}>{FormatUtils.formatarValorTelaDecimal(item.performance_operador_peso, 2)}%</Td>
										<Td width={100} alignCenter fontSize={18}>{FormatUtils.formatarValorTelaDecimal(100, 2)}%</Td>
										<Td width={100} alignCenter fontSize={18}>{FormatUtils.formatarValorTelaDecimal(item.performance_operador_realizado, 2)}%</Td>
										<Td width={100} alignCenter fontSize={18}>{FormatUtils.formatarValorTelaDecimal(item.performance_operador_percentual_realizado, 2)}%</Td>
									</Tr>

									<Tr>
										<Td width={500} bold fontSize={18}>Resultado</Td>
										<Td width={100} bold alignCenter fontSize={18}>
											{FormatUtils.formatarValorTelaDecimal(
												parseFloat(item.visita_qualidade_peso || 0) 
												+ parseFloat(item.estoque_peso || 0) 
												+ parseFloat(item.performance_operador_peso || 0), 2)
											}%
										</Td>
										<Td width={100} bold alignCenter fontSize={18}></Td>
										<Td width={100} bold alignCenter fontSize={18}></Td>
										<Td width={100} bold alignCenter fontSize={18}>
											{FormatUtils.formatarValorTelaDecimal(
												parseFloat(item.visita_qualidade_percentual_realizado || 0) 
												+ parseFloat(item.estoque_percentual_realizado || 0) 
												+ parseFloat(item.performance_operador_percentual_realizado || 0), 2)
											}%
										</Td>
									</Tr>
								</TBody>
							</Table>
						);
					})}
				</ContentCardBody>
			</ContentCard>
		);
	}

	setModalReprocessar(registro) {
		this.setState({
			...this.state,
			modalRegistro: registro
		});
	}

	modalReprocessar() {

		if (!this.state.modalRegistro) {
			return null;
		}

		return (
			<div class='modal fade show' id='modal-xl' style={{ display: 'block' }} aria-modal='true'>
				<div class='modal-dialog modal-xl'>
					<div class='modal-content'>
						<div class='modal-header'>
							<h4 class='modal-title'>Reprocessar</h4>
							<button type='button' class='close' data-dismiss='modal' aria-label='Close' onClick={() => this.setModalReprocessar(null)}>
								<span aria-hidden='true'>×</span>
							</button>
						</div>
						<div class='modal-body'>		
							<Row>
								<Grid cols='12 12 12 12'>
									<label style={{ fontSize: 18 }}>Indicador I — Eficiência Operacional (Tempo de Carga/Descarga)</label>
								</Grid>
							</Row>
							<br />
							<Row>
								<LabelAndCheckbox
									label='Houve Incidente (Mês 1)'
									placeholder='Informe'
									cols='12 4 4 4'
									value={this.state.modalRegistro.operacional_incidente_mes1}
									onChange={() => {
										this.setModalReprocessar({
											...this.state.modalRegistro,
											operacional_incidente_mes1: !this.state.modalRegistro.operacional_incidente_mes1
										});
									}} />

								<LabelAndCheckbox
									label='Houve Incidente (Mês 2)'
									placeholder='Informe'
									cols='12 4 4 4'
									value={this.state.modalRegistro.operacional_incidente_mes2}
									onChange={() => {
										this.setModalReprocessar({
											...this.state.modalRegistro,
											operacional_incidente_mes2: !this.state.modalRegistro.operacional_incidente_mes2
										});
									}} />								
                				
								<LabelAndCheckbox
									label='Houve Incidente (Mês 3)'
									placeholder='Informe'
									cols='12 4 4 4'
									value={this.state.modalRegistro.operacional_incidente_mes3}
									onChange={() => {
										this.setModalReprocessar({
											...this.state.modalRegistro,
											operacional_incidente_mes3: !this.state.modalRegistro.operacional_incidente_mes3
										});
									}} />
							</Row>

							<br />
                
							<Row>
								<Grid cols='12 12 12 12'>
									<label style={{ fontSize: 18 }}>Indicador III — Cumprimento de Leis e Normas Internas</label>
								</Grid>
							</Row>
							<br />
							<Row>
								<Grid cols='12 12 12 12'>
									<label>Mês 1</label>
								</Grid>
							</Row>
							<Row>
								<LabelAndCheckbox
									label='Não registrou checklist de gabine'
									placeholder='Informe'
									cols='12 4 4 4'
									value={this.state.modalRegistro.qualidade_perdeu_checklist_gabine_mes1}
									onChange={() => {
										this.setModalReprocessar({
											...this.state.modalRegistro,
											qualidade_perdeu_checklist_gabine_mes1: !this.state.modalRegistro.qualidade_perdeu_checklist_gabine_mes1
										});
									}} />

								<LabelAndCheckbox
									label='Autuação por inobservância de norma ou lei'
									placeholder='Informe'
									cols='12 4 4 4'
									value={this.state.modalRegistro.qualidade_perdeu_lei_norma_mes1}
									onChange={() => {
										this.setModalReprocessar({
											...this.state.modalRegistro,
											qualidade_perdeu_lei_norma_mes1: !this.state.modalRegistro.qualidade_perdeu_lei_norma_mes1
										});
									}} />								
                				
								<LabelAndCheckbox
									label='Dano caudado por conduta imprudente'
									placeholder='Informe'
									cols='12 4 4 4'
									value={this.state.modalRegistro.qualidade_perdeu_imprudencia_mes1}
									onChange={() => {
										this.setModalReprocessar({
											...this.state.modalRegistro,
											qualidade_perdeu_imprudencia_mes1: !this.state.modalRegistro.qualidade_perdeu_imprudencia_mes1
										});
									}} />
							</Row>
							<Row>
								<Grid cols='12 12 12 12'>
									<label>Mês 2</label>
								</Grid>
							</Row>
							<Row>
								<LabelAndCheckbox
									label='Não registrou checklist de gabine (Mês 2)'
									placeholder='Informe'
									cols='12 4 4 4'
									value={this.state.modalRegistro.qualidade_perdeu_checklist_gabine_mes2}
									onChange={() => {
										this.setModalReprocessar({
											...this.state.modalRegistro,
											qualidade_perdeu_checklist_gabine_mes2: !this.state.modalRegistro.qualidade_perdeu_checklist_gabine_mes2
										});
									}} />

								<LabelAndCheckbox
									label='Autuação por inobservância de norma ou lei'
									placeholder='Informe'
									cols='12 4 4 4'
									value={this.state.modalRegistro.qualidade_perdeu_lei_norma_mes2}
									onChange={() => {
										this.setModalReprocessar({
											...this.state.modalRegistro,
											qualidade_perdeu_lei_norma_mes2: !this.state.modalRegistro.qualidade_perdeu_lei_norma_mes2
										});
									}} />								
                				
								<LabelAndCheckbox
									label='Dano caudado por conduta imprudente'
									placeholder='Informe'
									cols='12 4 4 4'
									value={this.state.modalRegistro.qualidade_perdeu_imprudencia_mes2}
									onChange={() => {
										this.setModalReprocessar({
											...this.state.modalRegistro,
											qualidade_perdeu_imprudencia_mes2: !this.state.modalRegistro.qualidade_perdeu_imprudencia_mes2
										});
									}} />
							</Row>
							<Row>
								<Grid cols='12 12 12 12'>
									<label>Mês 3</label>
								</Grid>
							</Row>
							<Row>
								<LabelAndCheckbox
									label='Não registrou checklist de gabine'
									placeholder='Informe'
									cols='12 4 4 4'
									value={this.state.modalRegistro.qualidade_perdeu_checklist_gabine_mes3}
									onChange={() => {
										this.setModalReprocessar({
											...this.state.modalRegistro,
											qualidade_perdeu_checklist_gabine_mes3: !this.state.modalRegistro.qualidade_perdeu_checklist_gabine_mes3
										});
									}} />

								<LabelAndCheckbox
									label='Autuação por inobservância de norma ou lei'
									placeholder='Informe'
									cols='12 4 4 4'
									value={this.state.modalRegistro.qualidade_perdeu_lei_norma_mes3}
									onChange={() => {
										this.setModalReprocessar({
											...this.state.modalRegistro,
											qualidade_perdeu_lei_norma_mes3: !this.state.modalRegistro.qualidade_perdeu_lei_norma_mes3
										});
									}} />								
                				
								<LabelAndCheckbox
									label='Dano caudado por conduta imprudente'
									placeholder='Informe'
									cols='12 4 4 4'
									value={this.state.modalRegistro.qualidade_perdeu_imprudencia_mes3}
									onChange={() => {
										this.setModalReprocessar({
											...this.state.modalRegistro,
											qualidade_perdeu_imprudencia_mes3: !this.state.modalRegistro.qualidade_perdeu_imprudencia_mes3
										});
									}} />
							</Row>
							
							<Row alignCenter>
								<Grid cols='6 6 4 3'>									
									<Button
										text='Confirmar'
										type={'success'}
										icon={'fa fa-check'}
										event={() => {
											this.props.processarApuracao({
												...this.state.modalRegistro
											}, () => this.setModalReprocessar(null));
										}} />
								</Grid>
							</Row>
						</div>
					</div>
				</div>
			</div>
		);
	}

}

const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	usuarioCarregado: state.auth.usuarioCarregado,
	modoTela: state.metaBaseSupervisorTrimestre.modoTela,
	filtro: state.metaBaseSupervisorTrimestre.filtro,
	lista: state.metaBaseSupervisorTrimestre.listaMetaApuracao,
	listaApuracao: state.metaBaseSupervisorTrimestre.listaApuracao
});
const mapDispatchToProps = dispatch => bindActionCreators({ 
	setModoTela, initForm, salvar, excluir, processarApuracao,
	getListaMetaApuracao, importarCustos,
	imprimir
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(MetaBaseSupervisorTrimestreApuracao);
